import { render, staticRenderFns } from "./violationDetail.vue?vue&type=template&id=5fbf60b5&scoped=true"
import script from "./violationDetail.vue?vue&type=script&lang=js"
export * from "./violationDetail.vue?vue&type=script&lang=js"
import style0 from "./violationDetail.vue?vue&type=style&index=0&id=5fbf60b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf60b5",
  null
  
)

export default component.exports